import TallahasseeHeroSection from "./components/HeroSection";
import TallahasseeStickyNav from "./components/StickyNav";
import TallahasseeProcessingTimeSection from "./components/ProcessingTimeSection";
import TallahasseeServicesSection from "./components/ServicesSection";
import TallahasseeLocalAreaSection from "./components/LocalAreaSection";
import TallahasseeTestimonialsSection from "./components/TestimonialsSection";
import TallahasseeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TallahasseeComparisonSection from "./components/ComparisonSection";
import TallahasseeMistakesSection from "./components/MistakesSection";
import TallahasseeHowItWorksSection from "./components/HowItWorksSection";
import TallahasseeFAQSection, { faqs } from "./components/FAQSection";
import TallahasseeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TallahasseeFinalCTA from "./components/FinalCTA";
import TallahasseeTravelTimingSection from "./components/TravelTimingSection";
import TallahasseeDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function TallahasseePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Tallahassee"
        state="Florida"
        stateAbbr="FL"
        route="/cities/tallahassee"
        title="Emergency Passport Tallahassee, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Tallahassee, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Leon County, FSU, FAMU, and the Big Bend region."
        geoPlacename="Tallahassee, Florida"
        geoPosition="30.4383;-84.2807"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <TallahasseeHeroSection />
      <TallahasseeStickyNav />
      <TallahasseeProcessingTimeSection />
      <TallahasseeServicesSection />
      <TallahasseeLocalAreaSection />
      <TallahasseeTravelTimingSection />
      <TallahasseeDestinationsSection />
      <TallahasseeTestimonialsSection />
      <TallahasseeAcceptanceFacilitiesSection />
      <TallahasseeComparisonSection />
      <TallahasseeMistakesSection />
      <TallahasseeHowItWorksSection />
      <TallahasseeFAQSection />
      <TallahasseeHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/tallahassee" state="FL" />
      <TallahasseeFinalCTA />
    </div>
  );
}